import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import queryString from 'query-string'

import { checkEmail, checkAssessorEmailAvailability } from 'redux/modules/api/asyncValidations'
import {
  profile as profileActions,
  registration as registrationActions,
  participants as participantsActions,
  signoff as signoffActions,
  assessors as assessorsActions
} from 'redux/modules/api/assessor'
import { notification, modal, logError } from 'redux/modules/app'
import { createAssessorSchema, uploadFileAssessorWWCSchema, createAssessorActivityCategoryRegistrationSchema, uploadFileForAssessedActivitySchema } from 'models/assessor'
import { ACTIVITY_STATES, ASSESSOR_WWC_STATE_TYPES } from 'constants/enums'
import { sortAssessorParticipants } from 'redux/selectors/participants'
import configFile from 'config'
import { blob as blobApi } from '../../../../redux/modules/api'


const decorator = (config = {}) => ComposedComponent => {
  @connect(
    ({ app, api, auth }) => ({
      localeId: app.locale.id,
      persons: api.dashboard.persons,
      assessor: api.assessor,
      personId: get(auth, 'user.personId')
    }),
    {
      notification,
      modal,
      checkEmail,
      checkAssessorEmailAvailability,
      push,
      logError,
      ...profileActions,
      ...registrationActions,
      ...participantsActions,
      ...signoffActions,
      ...assessorsActions,
      putBlob: blobApi.putBlob,
    }
  )
  class Assessors extends Component {
    static propTypes = {
      checkEmail: PropTypes.func,
      checkAssessorEmailAvailability: PropTypes.func,
      loadAssessor: PropTypes.func,
      notification: PropTypes.func,
      logError: PropTypes.func,
      createAssessor: PropTypes.func,
      createAssessorActivityCategoryRegistration: PropTypes.func,
      getAvailableAssessorsForActivityCategory: PropTypes.func,
      getAssessorOverview: PropTypes.func,
      updateWWC: PropTypes.func,
      getWWCList: PropTypes.func,
      loadAssessorParticipants: PropTypes.func,
      loadAssessorActivityCategoryRegistration: PropTypes.func,
      loadFilesForAssessedActivity: PropTypes.func,
      loadFilesForActivityRegistration: PropTypes.func,
      loadAssessorWWCFile: PropTypes.func,
      loadAssessorWWCStatus: PropTypes.func,
      updateWWCFile: PropTypes.func,
      updateWWCWithoutFile: PropTypes.func,
      uploadFileForAssessedActivity: PropTypes.func,
      uploadAssessorWWCFile: PropTypes.func,
      deleteFileForAssessedActivity: PropTypes.func,
      deleteAssessorWWCFile: PropTypes.func,
      updateAssessorActivity: PropTypes.func,
      acceptActivity: PropTypes.func,
      localeId: PropTypes.number,
      assessmentSignOff: PropTypes.func,
      push: PropTypes.func,
      modal: PropTypes.func,
      rejectAssessorInvitation: PropTypes.func,
      location: PropTypes.object,
      persons: PropTypes.object,
      putBlob: PropTypes.func,
      personId: PropTypes.number.isRequired,
      acceptActivityByLink: PropTypes.func,
      rejectActivityByLink: PropTypes.func
    }

    componentDidMount() {
      get(this.props.persons, 'profile.data.email') &&
        config.loadParticipants &&
        this.handleLoadParticipants(get(this.props, 'assessor.participants'), {
          redirect: true,
          assessorEmail: get(this.props.persons, 'profile.data.email')
        })
      config.loadWWCStatus && this.handleGetWWCList(this.props.personId)
    }

    componentWillReceiveProps = nextProps => {
      if (
        get(this.props.persons, 'profile.data.email') !==
        get(nextProps.persons, 'profile.data.email')
      ) {
        this.handleLoadParticipants(get(nextProps, 'assessor.participants'), {
          redirect: true,
          assessorEmail: get(nextProps.persons, 'profile.data.email')
        })
      }

      if (
        get(this.props, 'assessor.participants.filter') !== get(nextProps, 'assessor.participants.filter')
      ) {
        config.loadParticipants &&
        this.handleLoadParticipants(get(nextProps, 'assessor.participants'), {
          redirect: true,
          assessorEmail: get(this.props.persons, 'profile.data.email')
        })
      }
    }

    handleLoadFilesForAssessedActivity = (id, assessorId = 0, authCode) => {
      this.props.loadFilesForAssessedActivity(id, assessorId, authCode)
    }

    handleLoadFilesForActivityRegistration = authCode => {
      this.props.loadFilesForActivityRegistration(authCode)
    }

    handleLoadAssessorWWCFile = authCode => {
      return this.props.loadAssessorWWCFile(authCode)
    }

    handleLoadParticipants = async(participantsObj, options) => {
      try {
        const { loadAssessorParticipants, params } = this.props
        const { body: participants } = await loadAssessorParticipants(participantsObj, options)

        if (get(options, 'redirect')) {
          this.handleOnLoadRedirect(
            sortAssessorParticipants(participants, options),
            {
              hasParticipants: get(participants, 'length', []) > 0,
              hasId: !get(params, 'activityId')
            }
          )
        }
      } catch (err) {
        this.handleError(err)
      }
    }

    handleLoadAssessorWWCStatus = personId => {
      return this.props.loadAssessorWWCStatus(personId)
    }

    handleGetWWCList = personId => {
      this.props.getWWCList(personId)
    }

    handleUpdateWWCFile = (fields, authCode) => {
      return this.props.putBlob({ blob: fields.file, fileName: fields.file.name }, authCode)
        .then(({ body = {} }) => {
          const data = { ...fields, fileUrl: body.url }

          delete data.file
          return this.props.updateWWCFile(data)
            .then(() => {
              this.handleSuccess(
                'File has been uploaded',
                'notifications.file_has_been_uploaded'
              )
              this.handleLoadAssessorWWCStatus(this.props.personId)
            })
            .catch(this.handleError)
        })
        .catch(this.handleError)
    }

    handleUpdateWWCWithoutFile = fields => {
      const data = { ...fields }

      return this.props.updateWWCWithoutFile(data)
        .then(() => {
          this.handleSuccess(
            'WWC has been updated',
            'notifications.wwc_has_been_updated'
          )
          this.handleLoadAssessorWWCStatus(this.props.personId)
        })
        .catch(this.handleError)
    }

    handleOnLoadRedirect = (participants = [], options = {}) => {
      if (!options.hasParticipants) {
        this.props.push(`${configFile.publicPath}/assessor`)
        return
      }

      const participantSection = participants[0] || {}

      const wwcExpirationDate = participantSection && get(participantSection, 'assessor.assessorWWC.childProtectionExpirationDate')

      const wwcState = get(participantSection, 'assessor.assessorWWC.state.value')

      const isPending = wwcState && wwcState === ASSESSOR_WWC_STATE_TYPES.pending.id

      const expiredWWC = wwcExpirationDate && (new Date(wwcExpirationDate) < new Date())

      if (expiredWWC && !isPending) {
        this.props.push(`${configFile.publicPath}/assessor/expired-wwc`)
      } else if(isPending) {
        this.props.push(`${configFile.publicPath}/assessor/pending-wwc`)
      }else {
        this.props.push(`${configFile.publicPath}/assessor/`)
      }
    }

    determineOrder = (state = {}, { isAssessmentPositive = false } = {}) => {
      switch (state.value) {
        case ACTIVITY_STATES.assessment.id:
          return !isAssessmentPositive ? 10 : 9
        case ACTIVITY_STATES.in_progress.id:
          return 8
        case ACTIVITY_STATES.award_leader_singoff.id:
          return 7
        default:
          return 1
      }
    }

    handleCheckEmail = params =>
      this.props
        .checkEmail(params)
        .then(({ body }) => body || false)
        .catch(({ body }) => body || false)

    handleCheckAssessorEmailAvailability = (email, orgId, activityCategoryId) => {
      this.props.checkAssessorEmailAvailability(email, orgId, activityCategoryId)
        .then(({ body }) => body || false)
        .catch(({ body }) => body || false)
    }

    handleCreateAssessor = (fields, authCode) => {
      const { localeId, createAssessor } = this.props

      return createAssessor(
        createAssessorSchema(fields, localeId),
        authCode
      ).catch(this.handleError)
    }

    handleCreateActivityCategoryRegistration = (fields, data, authCode) => {
      const { createAssessorActivityCategoryRegistration } = this.props

      return createAssessorActivityCategoryRegistration(createAssessorActivityCategoryRegistrationSchema(fields, data), authCode)
        .catch(this.handleError)
    }

    getAvailableAssessorsForActivityCategory = (orgId, activityCategoryId) => {
       return this.props.getAvailableAssessorsForActivityCategory(orgId, activityCategoryId)
        .catch(this.handleError)
    }

    getAssessorOverview = assessorId => {
       return this.props.getAssessorOverview(assessorId)
        .catch(this.handleError)
    }

    handleUpdateWWC = (personId, orgId, data) => {
      return this.props.updateWWC(personId, orgId, data)
        .then(() => {
          this.props.notification('WWC has been updated successfully', { status: 'success', intlKey: 'notifications.wwc_updated_successfully' })
        })
        .catch(this.handleError)
   }

    handleLoadAssessor = authCode => {
      return this.props.loadAssessor(authCode).catch(err => {
        if (
          ['UNAUTHORIZED', 'FORBIDDEN'].includes(get(err, 'body.errorCode'))
        ) {
          this.props.notification('Assessor registration link has expired.', {
            intlKey: 'notifications.assessor_link_expired',
            status: 'error'
          })
          return this.props.push(`${configFile.publicPath}/`)
        }

        this.handleError(err)
      })
    }

    handleLoadAssessorActivityCategoryRegistration = authCode => {
      return this.props.loadAssessorActivityCategoryRegistration(authCode).catch(err => {
        if (
          ['UNAUTHORIZED', 'FORBIDDEN'].includes(get(err, 'body.errorCode'))
        ) {
          this.props.notification('Assessor registration link has expired.', {
            intlKey: 'notifications.assessor_link_expired',
            status: 'error'
          })
          return this.props.push(`${configFile.publicPath}/`)
        }

        this.handleError(err)
      })
    }

    handleSignOff = (fields, { approved, activityId, activitySection } = {}) =>
      this.props
        .assessmentSignOff(activityId, activitySection, {
          note: get(fields, 'note'),
          assessorReportDetail: {
            assessorReport: get(fields, 'assessorReport'),
            assessorReportAdditionalInfo: get(fields, 'assessorReportAdditionalInfo') },
          approved: Boolean(approved)
        })
        .then(() => {
          this.handleSuccess(
            `Assessment has been successfully ${
              approved ? 'approved' : 'rejected'
            }.`,
            `notifications.assessment_${approved ? 'approved' : 'rejected'}`
          )
        })
        .catch(this.handleError)

    handleAcceptActivity = (fields, isAccepted, activityId, residentialProjectId, ajId) => {
      const data = {
        reason: get(fields, 'reason'),
        isAccepted: Boolean(isAccepted),
        activityId,
        residentialProjectId,
        ajId
      }

      this.props.acceptActivity(this.props.personId, data).then(() => {
          this.handleSuccess(
            `Activity has been successfully ${
              isAccepted ? 'accepted' : 'rejected'
            }.`,
            `notifications.activity_${isAccepted ? 'accepted' : 'rejected'}`
          )
        })
        .catch(this.handleError)
    }

    handleRejectActivity = (fields, authCode) => {
      const isAccepted = false

      const data = {
        reason: get(fields, 'reason'),
        isAccepted: isAccepted
      }

      return this.props.rejectActivityByLink(data, authCode)
        .catch(this.handleError)
    }

    handleRejectAssessorInvitation = async(authCode, fields) => {
      const { rejectAssessorInvitation, notification } = this.props

      try {
        await rejectAssessorInvitation(authCode, fields)
        this.props.push(`${configFile.publicPath}/`)
        notification('Invitation to become assessor has been rejected', {
          status: 'success',
          intlKey: 'notifications.assessor_invitation_rejected'
        })
      } catch (err) {
        this.handleError(err)
        this.props.push(`${configFile.publicPath}/`)
      }
    }

    handleUploadAssessorFile = (fields, authCode, data) => {
      const activityId = get(data, 'activityId')

      const activityCategoryId = get(data, 'activityCategoryId')

      const ajEventId = get(data, 'ajEventId')

      const residentialProjectId = get(data, 'residentialProjectId')

      const assessorId = get(data, 'assessorId')

      const withoutAssessor = get(data, 'withoutAssessor')

      const id = activityId || ajEventId || residentialProjectId || residentialProjectId || activityCategoryId

      const assessorRegistrationId = get(data, 'assessorRegistrationId')

    if (!fields.file) { return }
              this.props.putBlob({ blob: fields.file, fileName: fields.file.name }, authCode, { assessorRegistrationId })
                .then(({ body = {} }) => {
                  this.props
                    .uploadFileForAssessedActivity(
                      uploadFileForAssessedActivitySchema(fields, body.url, data),
                      authCode
                    )
                    .then(() => {
                      this.handleSuccessFile(
                        'File has been uploaded',
                        'notifications.file_has_been_uploaded'
                      )
                      if (withoutAssessor) {
                        this.handleLoadFilesForActivityRegistration(authCode)
                      } else {
                        this.handleLoadFilesForAssessedActivity(id, assessorId, authCode)
                      }
                    })
                    .catch(this.handleError)
                })
                .catch(this.handleError)
    }


    handleUploadAssessorWWCFile = (fields, authCode, data) => {
      if (!fields.file) { return }

      const assessorRegistrationId = get(data, 'assessorRegistrationId')

      this.props.putBlob({ blob: fields.file, fileName: fields.file.name }, authCode, { assessorRegistrationId })
        .then(({ body = {} }) => {
          this.props
            .uploadAssessorWWCFile(uploadFileAssessorWWCSchema(fields, body.url), authCode)
            .then(() => {
              this.handleSuccessFile(
                'File has been uploaded',
                'notifications.file_has_been_uploaded'
              )
              this.handleLoadAssessorWWCFile(authCode)
            })
            .catch(this.handleError)
        })
        .catch(this.handleError)
    }

    handleDeleteFilesForAssessedActivity = data => {
      const id = get(data, 'id')

      const assessorId = get(data, 'assessorId')

      const fid = get(data, 'item.id')

      const authCode = get(data, 'authCode')

      const withoutAssessor = get(data, 'withoutAssessor')

      this.props.deleteFileForAssessedActivity(fid, authCode)
        .then(() => {
          this.handleSuccessFile(
            'File has been removed',
            'notifications.file_has_been_removed'
          )

          if(withoutAssessor){
            this.handleLoadFilesForActivityRegistration(authCode)
          } else {
            this.handleLoadFilesForAssessedActivity(id, assessorId, authCode)
          }
        })
        .catch(this.handleError)
    }

    handleDeleteAssessorWWCFile = data => {
      const fid = get(data, 'wwcFileId')

      const authCode = get(data, 'authCode')

      this.props.deleteAssessorWWCFile(fid, authCode)
        .then(() => {
          this.handleSuccessFile(
            'File has been removed',
            'notifications.file_has_been_removed'
          )
          this.handleLoadAssessorWWCFile(authCode)
        })
        .catch(this.handleError)
    }

    handleUpdateAssessorActivity = (id, data) => {
      this.props.updateAssessorActivity(id, data)
        .then(() => {
          this.handleSuccessFile(
            'Affiliation as been updated successfully',
            'notifications.assessor_activity_updated_successfully'
          )
        })
        .catch(this.handleError)
    }

    handleError = err => {
      const query = queryString.parse(get(this.props, 'location.search'))
      const authCode = get(query, 'authorizationCode')

      return this.props.logError(err, {
        authCode
      })
    }

    handleSuccessFile = (
      text = 'Success',
      intlKey = 'notifications.success',
    ) => {
      this.props.notification(text, { status: 'success', intlKey })
      this.props.modal(null, null)
    }

    handleSuccess = (
      text = 'Success',
      intlKey = 'notifications.success',
      resetForm
    ) => {
      this.handleLoadParticipants(get(this.props, 'assessor.participants'), {
        assessorEmail: get(this.props.persons, 'profile.data.email')
      })
      this.props.notification(text, { status: 'success', intlKey })
      this.props.modal(null, null)
      resetForm && resetForm()
    }

    render() {
      return (
        <ComposedComponent
          onCheckEmail={this.handleCheckEmail}
          onCheckAssessorEmailAvailability={this.handleCheckAssessorEmailAvailability}
          onCreateAssessor={this.handleCreateAssessor}
          onCreateActivityCategoryRegistration={this.handleCreateActivityCategoryRegistration}
          onGetAvailableAssessorsForActivityCategory={this.getAvailableAssessorsForActivityCategory}
          onGetAssessorOverview={this.getAssessorOverview}
          onUpdateWWC={this.handleUpdateWWC}
          onLoadAssessor={this.handleLoadAssessor}
          onLoadAssessorActivityCategoryRegistration={this.handleLoadAssessorActivityCategoryRegistration}
          onRejectAssessorInvitation={this.handleRejectAssessorInvitation}
          onSignOff={this.handleSignOff}
          onAcceptActivity={this.handleAcceptActivity}
          onRejectActivity={this.handleRejectActivity}
          onUploadAssessorWWCFile={this.handleUploadAssessorWWCFile}
          onUploadAssessorFile={this.handleUploadAssessorFile}
          onLoadAssessorFile={this.handleLoadFilesForAssessedActivity}
          onLoadFilesForActivityRegistration={this.handleLoadFilesForActivityRegistration}
          onLoadAssessorWWCFile={this.handleLoadAssessorWWCFile}
          onLoadAssessorWWCStatus={this.handleLoadAssessorWWCStatus}
          onUpdateWWCFile={this.handleUpdateWWCFile}
          onUpdateWWCWithoutFile={this.handleUpdateWWCWithoutFile}
          onGetWWCList={this.handleGetWWCList}
          onDeleteAssessorFile={this.handleDeleteFilesForAssessedActivity}
          onDeleteAssessorWWCFile={this.handleDeleteAssessorWWCFile}
          onUpdateAssessorActivity={this.handleUpdateAssessorActivity}
          onLoadParticipants={() =>
            this.handleLoadParticipants(get(this.props, 'assessor.participants'), {
              redirect: true,
              assessorEmail: get(this.props.persons, 'profile.data.email')
            })
          }
          {...this.props}
        />
      )
    }
  }
  return Assessors
}

export default decorator
